import React, { useEffect, useState } from "react";
import "./Activity.css";
import { Modal } from "react-bootstrap";
import activitiesIcon from "../../assets/images/packages/svg/mountain.svg";
import { formatDuration } from "../../utils/GeneralFunctions";
import dayjs from "dayjs";
import { ToastContainer } from "react-toastify";
import { Tooltip } from "react-tooltip";
import { useTranslation } from "../../contexts/TranslationContext";
import Cookies from "js-cookie";
import FluentInfo from "../../assets/images/packages/svg/fluent_info.svg";

const Activity = ({
  item,
  duration,
  selectedDestination,
  image,
  title,
  startDate,
  endDate,
  formattedEndDate,
  formattedStartDate,
  dateSelected,
  onReturn,
  showCatalogDescription = false,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imgError, setImgError] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useTranslation();

  const Lang = Cookies.get("preferred_language") || "en";

  const handleCloseModal = () => setShowModal(false);
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    setImgError(false);
  }, [image]);

  useEffect(() => {
    setIsExpanded(false);
  }, [item?.description, item?.name, title]);

  const handleDayClick = (date) => {
    setSelectedDate(date);
  };

  const handleAddActivity = async () => {
    if (!selectedDate || !onReturn) {
      return;
    }

    setLoading(true);

    try {
      const result = await onReturn([
        {
          package_component_type: "All Time Activity",
          package_component_id: item.name,
          destination_row_id: selectedDestination?.primary_destination_row_id,
          date_from: dayjs(selectedDate).format("YYYY-MM-DD HH:mm:ss"),
          date_to: null,
          from_destination: item.destination,
        },
      ]);

      if (result) {
        setShowModal(false);
        setSelectedDate(null);
      }
    } finally {
      setLoading(false);
    }
  };

  const datesArray = [];
  let currentDate = dayjs(startDate);
  const finalDate = dayjs(endDate);

  while (currentDate.isSameOrBefore(finalDate, "day")) {
    datesArray.push(currentDate.toDate());
    currentDate = currentDate.add(1, "day");
  }

  return (
    <div className="activity-container">
      <div className="activity-image">
        {dateSelected && (
          <div className="activity-date-selected">{dateSelected}</div>
        )}
        {
          <div
            className="add-activity-btn"
            onClick={() => {
              setShowModal(true);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 16 16"
              fill="none"
            >
              <g clip-path="url(#clip0_1390_2266)">
                <path
                  d="M13.7776 6.66645H9.33312V2.22201C9.33312 1.86838 9.19264 1.52924 8.94259 1.2792C8.69254 1.02915 8.3534 0.888672 7.99978 0.888672C7.64616 0.888672 7.30702 1.02915 7.05697 1.2792C6.80692 1.52924 6.66645 1.86838 6.66645 2.22201V6.66645H2.22201C1.86838 6.66645 1.52924 6.80692 1.2792 7.05697C1.02915 7.30702 0.888672 7.64616 0.888672 7.99978C0.888672 8.3534 1.02915 8.69254 1.2792 8.94259C1.52924 9.19264 1.86838 9.33312 2.22201 9.33312H6.66645V13.7776C6.66645 14.1312 6.80692 14.4703 7.05697 14.7204C7.30702 14.9704 7.64616 15.1109 7.99978 15.1109C8.3534 15.1109 8.69254 14.9704 8.94259 14.7204C9.19264 14.4703 9.33312 14.1312 9.33312 13.7776V9.33312H13.7776C14.1312 9.33312 14.4703 9.19264 14.7204 8.94259C14.9704 8.69254 15.1109 8.3534 15.1109 7.99978C15.1109 7.64616 14.9704 7.30702 14.7204 7.05697C14.4703 6.80692 14.1312 6.66645 13.7776 6.66645Z"
                  fill="#27346A"
                />
              </g>
              <defs>
                <clipPath id="clip0_1390_2266">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        }

        {!image || imgError ? (
          <div className="activity-no-image">
            <img src={activitiesIcon} alt="Unavailable" />
          </div>
        ) : (
          <img
            src={image}
            onError={(event) => {
              event.target.onerror = null;
              setImgError(true);
            }}
            alt={title || "Activity"}
          />
        )}
      </div>
      <div
        className={`activity-info-container ${
          showCatalogDescription ? "activity-info-container-stacked" : ""
        }`}
      >
        <div className={`activity-title ${showCatalogDescription ? "no-border" : ""}`}>
          {title}
        </div>
        {!showCatalogDescription && (
          <div style={{ position: "relative", display: "inline-block" }}>
            <img
              src={FluentInfo}
              data-tooltip-id={`tooltip-${item?.name || item?.id || "activity"}`}
              data-tooltip-content={item?.description || t("NoDescription")}
              alt="info"
              style={{ cursor: "pointer", marginRight: "8px" }}
            />
            <Tooltip
              id={`tooltip-${item?.name || item?.id || "activity"}`}
              place="top"
              className="activity-tooltip"
              style={{
                whiteSpace: "normal",
                maxWidth: "300px",
                wordBreak: "break-word",
                padding: "10px",
                lineHeight: 1.3,
                overflowWrap: "break-word",
                zIndex: 9999,
              }}
            />
          </div>
        )}
      </div>

      {showCatalogDescription && item?.description && (
        <div className="activity-card-copy">
          <div
            className={`activity-description ${isExpanded ? "expanded" : ""}`}
          >
            {item.description}
          </div>
          {item.description.length > 120 && (
            <button
              type="button"
              className="activity-read-more"
              onClick={(event) => {
                event.stopPropagation();
                setIsExpanded((prev) => !prev);
              }}
            >
              {isExpanded
                ? t("ShowLess") || "Show less"
                : t("ReadMore") || "ReadMore"}
            </button>
          )}
        </div>
      )}

      {!showCatalogDescription && duration && (
        <div className="activity-duration">
          <div> {t("Duration")}</div>
          <span>{formatDuration(duration, t)}</span>
        </div>
      )}

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        className={`choose-activity-modal ${Lang === "ar" ? "rtl" : "ltr"}`}
        centered  
      >
        <Modal.Body className="choose-activity-modal-content">
          <div className="choose-activity-modal-icon">
            <img src={activitiesIcon} alt="Activity" />
          </div>
          <div className="choose-activity-modal-title">
            {" "}
            {t("AddActivities")}
          </div>
          <div className="choose-activity-modal-date">
            {`${formattedStartDate} - ${formattedEndDate}`}
          </div>
          <div className="choose-activity-modal-desc">
            {t("WhichDayWantAddActivity")}
          </div>
          <div className="choose-activity-day-btns">
            {datesArray.map((date, index) => {
              var date_f = dayjs(date).format("MMM D");
              date = dayjs(date).format("YYYY-MM-DD");
              const isSelected = selectedDate === date;
              return (
                <div
                  className={`choose-activity-day-btn ${
                    isSelected ? "active" : ""
                  }   `}
                  onClick={() => {
                    handleDayClick(date);
                  }}
                >
                  <div className="choose-activity-day-btn-title">
                    {t("Day")} {index + 1}
                  </div>
                  <div className="choose-activity-day">{date_f}</div>
                </div>
              );
            })}
          </div>
          <input
            type="submit"
            value={loading ? t("Loading") + "..." : t("Add")}
            onClick={() => {
              handleAddActivity();
            }}
            className={`activity-modal-add-btn ${loading ? "disabled" : ""}`}
            disabled={loading}
          />
        </Modal.Body>
      </Modal>
      <ToastContainer
        position="bottom-right"
        hideProgressBar="true"
        type="error"
      />
    </div>
  );
};

export default Activity;
